import React from 'react';
import PropTypes from 'prop-types';

import SmartImage from 'dpl/components/SmartImage';


export default function UserMobileHeaderDropdownTopSection({ userData }) {
  return (
    <div className="mb1 flex items-center">
      <p className="flex-auto f5 fw-medium">Hello, { userData.first_name || userData.name }!</p>
      <SmartImage
        Tag="div"
        className="br-100 cover bg-center"
        height="48px"
        src={ userData.profile_photo_url }
        width="48px"
        resize
      />
    </div>
  );
}

UserMobileHeaderDropdownTopSection.propTypes = {
  userData: PropTypes.shape({
    first_name: PropTypes.string,
    name: PropTypes.string,
    profile_photo_url: PropTypes.string
  }).isRequired
};
